import Hero from "../components/Hero";
import SeasonalBanner from "../components/SeasonalBanner";
import TrustBar from "../components/TrustBar";
import LiveSavingsTicker from "../components/LiveSavingsTicker";
import SavingsScorePromo from "../components/SavingsScorePromo";
import ComparisonExperience from "../components/ComparisonExperience";
import PressStrip from "../components/PressStrip";
import CategoryBento from "../components/CategoryBento";
import FeaturedTools from "../components/FeaturedTools";
import SavingsCalculator from "../components/SavingsCalculator";
import StateSavingsHeatmap from "../components/StateSavingsHeatmap";
import HomepageComparisonShelf from "../components/HomepageComparisonShelf";
import ContentHub from "../components/ContentHub";
import FAQ from "../components/FAQ";
import PartnerRateTable from "../components/PartnerRateTable";
import SEO from "../components/SEO";
import { FAQS } from "../lib/faqs";
import { organizationLd, websiteLd, speakableFaqPageLd } from "../lib/seo";

export default function Home() {
  return (
    <>
      {/* safe: $487/year sourced from data_sources `hero.insurance_savings`
          (Insurance Information Institute, 2024). The figure is rendered live
          + SourcesPopover-tagged on /auto-insurance; this static meta-description
          mirrors the same vetted claim. The drift-guard reads this annotation
          as provenance. */}
      <SEO
        title="Save Money on Car Ownership"
        description="Compare auto insurance, loans, and refinance offers in about 2 minutes. Free calculators, soft credit pulls — $1,100 average potential insurance savings."
        path="/"
        jsonLd={[organizationLd(), websiteLd(), speakableFaqPageLd(FAQS)]}
      />
      <main id="main-content" data-testid="home-page">
        {/* Iter-189 Sprint 4 — Above-hero seasonal banner. Renders
            null unless an admin has scheduled an active banner via
            /admin?tab=homepage-cms. Per-tab dismissable. */}
        <SeasonalBanner />
        <Hero />
        <TrustBar />
        {/* Iter-185.C (Sprint C · Live Savings Ticker) — Truthful
            real-time aggregate credibility surface. Reads directly
            from /api/stats; renders null if data unavailable. */}
        <LiveSavingsTicker />
        {/* Iter-275 — Multi-vertical Savings Opportunity Score promo. CarSavr's
            P0 competitive differentiator vs. Insurify / Compare.com (neither
            ships a multi-vertical savings tool). Funnels visitors to
            /savings-opportunity-score and ultimately into the 4 vertical
            funnels via the per-vertical CTAs on the reveal page. */}
        <SavingsScorePromo />
        <ComparisonExperience />
        {/* Iter-185.B (Sprint B · audit item H4) — Press / "As seen in"
            logo strip scaffold. Returns `null` until owner provides
            real placements (no placeholder logos = no truthfulness
            violation). When placements exist, this slot lights up
            automatically below the TrustBar. */}
        <PressStrip />
        <CategoryBento />
        <FeaturedTools />
        <SavingsCalculator />
        {/* Iter-185.D — State Savings Heatmap surfaces a color-graded
            d3-geo US map shaded by avg full-coverage premium per state.
            Reuses the iter-147 InteractiveUSMap component. Includes a
            geo-aware "your state" callout when ZIP resolves + a
            cheapest/national-avg/most-expensive stat strip. Powers
            both SEO (state pillar deep-links) and lead-funnel entry. */}
        <StateSavingsHeatmap />
        {/* Iter-185.B (Sprint B · audit item H8) — Tabbed comparison
            shelf consolidates the previous two consecutive sections
            (Insurance + Auto Loan tables) into a single tabbed surface.
            The inner editorial wrappers (rubric strips, intro
            paragraphs, see-all links) are preserved untouched.
            Iter-185.D — Top-section copy on both shelves refreshed to
            reflect the real audited carrier / lender mix (was stale at
            5 carriers; insurance now lists all 10). */}
        <HomepageComparisonShelf />
        {/* Iter-185.C (Sprint C · audit item M10) — CompareStrip retired
            from the homepage. It duplicated the CategoryBento + Featured
            Tools surfaces and added one redundant "ways to compare"
            block. Footer + drawer still expose all 4 compare entry
            points so the conversion path isn't reduced. */}
        <ContentHub />
        <FAQ />
      </main>
    </>
  );
}
